import { useMutation } from "react-query";
import approveSkuLoans from "../services/approveSkuLoan";

function useApproveSkuLoans() {
  return useMutation(["approve-sku-loan"], approveSkuLoans);
}

export default useApproveSkuLoans;
